export const handleQueryStrings = () => {
    const query = new URLSearchParams(window.location.search);

    const ppcid = query.get("ppcid") || '7';
    const cid = query.get("cid") || 'RateZip';

    const fullUrl = window.location.href;

    let buttonTitle = 'View Rate'
    let listingType = 'full';

    if (fullUrl.includes('/2')) {
        buttonTitle = "Learn More"
    }

    if (fullUrl.includes('/3')) {
        buttonTitle = "Open Account"
    }

    if (fullUrl.includes('/single-page')) {
        listingType = 'single';
    }

    if (fullUrl.includes('/single-page-s')) {
        listingType = 'single1';
    }

    if (fullUrl.includes('/single-page-cap')) {
        listingType = 'single2';
    }

    const queryObject = {
        ppcid,
        cid,
        buttonTitle,
        listingType
    };

    return queryObject;
}